import tw, { styled } from "twin.macro";

export const Wrapper = styled.nav`
  ${tw`py-6 sm:py-0 border-0 border-b sm:border-b-0 border-solid border-gray w-5/6 h-full`}

  ul{
    ${tw`m-0 p-0`}
    

    li{
      ${tw`inline px-4`}

      &:last-child{
        ${tw`pr-0`}
      }

      a{
        ${tw`no-underline text-white`}

        img{
          max-height: 1.3125rem;
        }
      }
    }
  }
`;
